<form [formGroup]="form" [caLocalizationScope]="localizationScope">
  <div class="body-70">
    <div class="input-group-with-side-label mb-5" data-automation-id="dataType-title">
      <label class="form-label-left">
        {{
          'dataType'
            | caLocalize
              : {
                  reportType: localizedReportType | async
                }
        }}
      </label>
    </div>

    @if ((drawerAction$ | async) === reportTemplateFormType.edit){
    <ng-container>
      @if (selectedTemplateDetails$ | async; as selectedTemplateDetails) {
      <div class="input-group-with-side-label mb-5" data-automation-id="lastUpdatedUserAndDate">
        <label class="form-label-left">{{ 'lastUpdated' | caLocalize }}</label>
        <span>
          {{
            'lastUpdatedUserAndDate'
              | caLocalize
                : {
                    name: selectedTemplateDetails?.userId | caAccountUserFullName,
                    dateTime: formatDate(selectedTemplateDetails?.dateTime) | async
                  }
          }}
        </span>
      </div>
      }
    </ng-container>
    }

    <div class="mb-5" data-automation-id="drawer-form-templateName">
      <label class="form-label-top">{{ 'reportTemplateName' | caLocalize }}<span class="text-danger">*</span></label>
      <input
        type="text"
        class="form-control form-control-outline"
        [placeholder]="'enterName' | caLocalize"
        formControlName="templateName"
        [ngClass]="{ 'is-invalid': showFormValidationError && templateNameCtrl?.touched && templateNameCtrl?.invalid }"
      />
      <ng-container *ngIf="showFormValidationError && templateNameCtrl?.touched">
        <div *ngIf="templateNameCtrl?.hasError('required')" class="invalid-feedback">
          {{ 'requiredField' | caLocalize }}
        </div>
        <div *ngIf="templateNameCtrl?.hasError('maxlength')" class="invalid-feedback">
          {{ 'templateNameMustBeLessThan255' | caLocalize }}
        </div>
        <div *ngIf="templateNameCtrl?.hasError('notUnique')" class="invalid-feedback">
          {{ 'templateNameExists' | caLocalize }}
        </div>
        <div *ngIf="templateNameCtrl?.hasError('invalidSymbols')" class="invalid-feedback">
          {{ 'invalidTemplateName' | caLocalize }}
        </div>
      </ng-container>
    </div>

    <div class="mb-5" data-automation-id="drawer-form-templateDescription">
      <label class="form-label-top">{{ 'templateDescription' | caLocalize }}</label>
      <textarea
        class="form-control form-control-outline"
        [placeholder]="'enterDescription' | caLocalize"
        formControlName="description"
        [ngClass]="{ 'is-invalid': descriptionCtrl?.touched && descriptionCtrl?.invalid }"
      ></textarea>
      <div *ngIf="descriptionCtrl?.touched && descriptionCtrl?.hasError('maxlength')" class="invalid-feedback">
        {{ 'descriptionMustBeLessThan1000' | caLocalize }}
      </div>
    </div>

    <div class="mb-5" data-automation-id="drawer-form-reportPageSize">
      <label class="form-label-top">{{ 'reportPageSize' | caLocalize }}<span class="text-danger">*</span></label>
      <select class="form-select form-select-outline" formControlName="pageSize">
        <option [selected]="isFirst" [value]="page.value" *ngFor="let page of pageSizes; first as isFirst">
          {{ page.label | caLocalize }}
        </option>
      </select>
    </div>
  </div>

  <div *caFeatureToggle="'BNY-Management-Report-ISD-9062'">
    <div *ngIf="reportType === ReportType.BnyManagementReport" data-automation-id="drawer-form-reportOrientation">
      <div class="input-group-with-side-label mb-5" data-automation-id="dataType-title">
        <label class="form-label-left">
          {{ 'orientationType' | caLocalize }}
        </label>
      </div>
    </div>
  </div>

  <div *ngIf="reportType === ReportType.Itinerary" data-automation-id="drawer-form-reportOrientation">
    <div class="input-group-with-side-label mb-5" data-automation-id="dataType-title">
      <label class="form-label-left">
        {{ 'orientationType' | caLocalize }}
      </label>
    </div>
  </div>

  <ng-template fDrawerFooterTemplate [caLocalizationScope]="localizationScope">
    <f-inline-alert [type]="Alert.Danger" *ngIf="showFormValidationError" rootCssClass="mt-1 mb-3">
      <div>
        {{ 'errorCreatingTemplate' | caLocalize }}
      </div>
    </f-inline-alert>

    <f-inline-alert
      [type]="Alert.Danger"
      *ngIf="showTemplateCreateError"
      (hideClick)="showTemplateCreateError = false"
      rootCssClass="mt-1 mb-3"
    >
      <div>
        {{ 'templateCreationFailedError' | caLocalize }}
      </div>
    </f-inline-alert>

    @if ((drawerAction$ | async) === reportTemplateFormType.create || (drawerAction$ | async) ===
    reportTemplateFormType.duplicate) {
    <ng-container>
      @if (!isTemplateLimitError && showBannerForTemplateLimit && (templatesLimitAlmostReached$ | async)) {
      <f-inline-alert [type]="Alert.Info" (hideClick)="showBannerForTemplateLimit = false" rootCssClass="mt-1 mb-3">
        <p class="body-70">
          {{ 'templatesLimitAlmostReached' | caLocalize }}
        </p>
      </f-inline-alert>
      } @if (isTemplateLimitError && showBannerForTemplateLimit) {
      <f-inline-alert [type]="Alert.Danger" (hideClick)="showBannerForTemplateLimit = false" rootCssClass="mt-1 mb-3">
        <p class="body-70">
          {{ 'templateLimitReached' | caLocalize }}
        </p>
      </f-inline-alert>
      }
    </ng-container>
    }

    <div class="footer-with-buttons">
      <button
        *ngIf="(drawerAction$ | async) === reportTemplateFormType.create"
        class="btn btn-primary position-relative"
        data-automation-id="navigate-template-designer-button"
        [title]="buttonType$ | async | caLocalize"
        (click)="saveAndContinue()"
        [disabled]="form.invalid"
      >
        {{ buttonType$ | async | caLocalize }}
        <f-spinner rootCssClass="spinner-center" *ngIf="saveStatus === loadStatus.Loading"></f-spinner>
      </button>
      <button
        *ngIf="(drawerAction$ | async) === reportTemplateFormType.duplicate"
        class="btn btn-primary position-relative"
        data-automation-id="navigate-template-designer-button"
        [title]="buttonType$ | async | caLocalize"
        (click)="saveDuplicate()"
        [disabled]="form.invalid"
      >
        {{ buttonType$ | async | caLocalize }}
        <f-spinner rootCssClass="spinner-center" *ngIf="saveStatus === loadStatus.Loading"></f-spinner>
      </button>

      <button
        *ngIf="(drawerAction$ | async) === reportTemplateFormType.duplicateWithoutContinue"
        class="btn btn-primary position-relative"
        data-automation-id="navigate-template-designer-button"
        [title]="buttonType$ | async | caLocalize"
        (click)="saveDuplicate()"
        [disabled]="form.invalid"
      >
        {{ buttonType$ | async | caLocalize }}
      </button>

      <button
        *ngIf="(drawerAction$ | async) === reportTemplateFormType.edit"
        class="btn btn-primary"
        data-automation-id="navigate-template-designer-button"
        [title]="buttonType$ | async | caLocalize"
        (click)="saveEditTemplate()"
      >
        {{ buttonType$ | async | caLocalize }}
      </button>

      <button
        class="btn btn-secondary"
        data-automation-id="cancel-drawer-button"
        [title]="'cancel' | caLocalize"
        (click)="dismiss()"
      >
        {{ 'cancel' | caLocalize }}
      </button>
    </div>
  </ng-template>
</form>
